import { FormBase } from 'core/components';

export default class FacilityOrderNewFlowUSIntakePatientNoteEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'note',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.NOTE_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}
